import { ReactNode } from "react";
import { Loader } from "shared/components/Loader";

type Props = {
  loading: boolean;
  message?: ReactNode;
  children?: ReactNode;
};

export const ComponentLoader = ({ children, loading }: Props) => {
  return loading ? (
    <div className="animate-appear flex h-screen items-center justify-center py-10">
      <Loader />
    </div>
  ) : (
    children
  );
};
